export default function MoreMenuTemplate(data) {
    //language=HTML
    return `
        <div class="nama-more-menu w-100 h-100">
            <input id="search" class="k-textbox w-100" placeholder='${data.translateId("search")}'/>
            <div class="moreActionsContainer w-100">
                <ul id='moreActionsMenu' class="w-100"></ul>
            </div>
        </div>`;
}